import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { ThemeProvider } from './ThemeProvider';
import LandingPage from './components/LandingPageGlassy';
import AuthPage from './components/AuthPage';
import PostJobForm from './components/PostJobForm';
import PostServiceForm from './components/PostServiceForm';
import Dashboard from './components/Dashboard';
import ProfileSettings from './components/ProfileSettings';
import Navigation from './components/Navigation';
import ServiceDetailsPage from './components/ServiceDetailsPage.jsx';
import EditServiceForm from './components/EditServiceForm';
import About from './pages/About';
import Contact from './pages/Contact';
import HowItWorks from './pages/Howitworks';
import Pricing from './pages/Pricing';
import Privacy from './pages/Privacy';
import Resources from './pages/Resources';
import Safety from './pages/Safety';
import Terms from './pages/Terms';
import BecomeAProvider from './pages/BecomeAProvider';
import JobDetailsPage from './components/JobDetailsPage';
import EditJobForm from './components/EditJobForm';
import VerifyEmail from './components/VerifyEmail';

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

function App() {
  return (
    <ThemeProvider>
      <Router>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/auth" element={<AuthPage />} />
          <Route path="/reset-password" element={<AuthPage />} />
          <Route path="/verify-email" element={<VerifyEmail />} />
          <Route path="/post-job" element={<PostJobForm />} />
          <Route path="/post-service" element={<PostServiceForm />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/profile" element={<ProfileSettings />} />
          <Route path="/navigation" element={<Navigation />} />
          <Route path="/service/:id" element={<ServiceDetailsPage />} />
          <Route path="/edit-service/:id" element={<EditServiceForm />} />
          <Route path="/edit-job/:id" element={<EditJobForm />} />
          <Route path="/job/:id" element={<JobDetailsPage />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/how-it-works" element={<HowItWorks />} />
          <Route path="/pricing" element={<Pricing />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/resources" element={<Resources />} />
          <Route path="/safety" element={<Safety />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/become-a-provider" element={<BecomeAProvider />} />
        </Routes>
      </Router>
    </ThemeProvider>
  );
}

export default App;